import { render, staticRenderFns } from "./diseaseDetail.vue?vue&type=template&id=ae01a2c2&scoped=true"
import script from "./diseaseDetail.vue?vue&type=script&lang=js"
export * from "./diseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./diseaseDetail.vue?vue&type=style&index=0&id=ae01a2c2&prod&scoped=true&lang=css"
import style1 from "./diseaseDetail.vue?vue&type=style&index=1&id=ae01a2c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae01a2c2",
  null
  
)

export default component.exports